<template>
  <div class="application--wrap">
    <nx-layout-default-toolbar :disabled="loadingApp" />

    <v-fade-transition>
      <div
        v-show="loadingApp"
        class="progress-wrapper"
      >
        <v-progress-circular
          class="progress-circular"
          indeterminate
          color="primary"
          :size="70"
        />
      </div>
    </v-fade-transition>

    <v-fade-transition>
      <div
        v-show="loadingView"
        class="progress-app-wrapper"
      >
        <nx-layout-default-progress-bar :active="true" />
      </div>
    </v-fade-transition>

    <v-content
      class="nx-view"
      :class="{ 'nx-view--bag-visible' : app.bag }"
    >
      <router-view
        v-show="!loadingView"
        :key="currentLocale"
      />
    </v-content>

    <nx-block-page-message />
    <nx-app-toast />
    <nx-app-dialog />
    <nx-auth-modal />
    <nx-onboarding-manager />
    <nx-staff-notification-just-notified-stack v-if="features.STAFF_NOTIFICATIONS" />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { availableToasts } from '@/modules/toast/config';
import NxOnboardingManager from '@/modules/onboarding/components/OnboardingManager';
import NxAppDialog from '@/modules/app-dialog/AppDialog';
import NxAppToast from '@/modules/toast/Toast';
import NxBlockPageMessage from '@/modules/block/PageMessages';
import NxLayoutDefaultProgressBar from '@/layouts/components/ProgressBar';
import NxLayoutDefaultToolbar from '@/layouts/components/Toolbar';
import NxStaffNotificationJustNotifiedStack from '@/modules/staff-notification/components/StaffNotificationJustNotifiedStack.vue';
import NxAuthModal from '@/modules/authentication/components/AuthModal.vue';

export default {
  name: 'Default',
  components: {
    NxStaffNotificationJustNotifiedStack,
    NxAuthModal,
    NxLayoutDefaultToolbar,
    NxLayoutDefaultProgressBar,
    NxBlockPageMessage,
    NxAppToast,
    NxAppDialog,
    NxOnboardingManager,
  },
  props: {
    toast: {
      type: String,
    },
  },
  data() {
    return {
      snackbar: true,
    };
  },
  computed: {
    ...mapGetters(['loadingApp', 'loadingView', 'features']),
    ...mapState({
      app: 'app',
      currentLocale: state => state.locale.current,
    }),
  },
  mounted() {
    if (!this.toast) {
      return;
    }
    // Delete the toast from current url
    const urlWithoutToast = new URL(document.location.href);
    urlWithoutToast.searchParams.delete('toast');
    window.history.replaceState({}, document.title, urlWithoutToast.href);

    // Show the toast
    if (!availableToasts[this.toast]) {
      return;
    }
    this.$store.dispatch('toast/CREATE', availableToasts[this.toast]);
  },
  beforeUpdate() {
    // Vuetify have problems when using multiple v-toolbar app (example: searcher page vs content page)
    // Set a default top if none is set
    if (!this.$vuetify.application.top) {
      this.$vuetify.application.top = 48;
    }
  },
};
</script>

<style lang="stylus" scoped>
.progress-wrapper {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 3;
  background-color: #fafafa;

  .progress-circular {
    left: 50%;
    top: 50%;
    transform: translate(-100%, -100%);
  }
}

.progress-app-wrapper {
  position: fixed;
  left: 0;
  top: 48px;
  bottom: 0;
  right: 0;
  background-color: #fafafa;
  z-index: 5;
}
</style>
